import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timetableSailing" }
const _hoisted_2 = { class: "contentWrapper" }
const _hoisted_3 = { class: "timeIconTimeWrapper" }
const _hoisted_4 = {
  key: 0,
  class: "stops"
}
const _hoisted_5 = {
  key: 0,
  class: "accordion"
}
const _hoisted_6 = { class: "accordionPanel" }
const _hoisted_7 = { class: "time" }

import { ref } from 'vue';
import { formatInTimeZone } from 'date-fns-tz';
import { timezone } from '../../envVariables';
import { Icon } from '../../Atoms';
import {
  IconText,
  TimeIconTime,
} from '..';
import { Stop } from '../../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableSailing',
  props: {
    departureTime: {},
    arrivalTime: {},
    isDelayed: { type: Boolean },
    delayedDepartureTime: {},
    delayedArrivalTime: {},
    isCancelled: { type: Boolean },
    viewStopsText: {},
    stops: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {


const expanded = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(TimeIconTime), {
          "departure-time": _ctx.departureTime,
          "arrival-time": _ctx.arrivalTime,
          "is-cancelled": _ctx.isCancelled ?? false,
          "is-delayed": _ctx.isDelayed ?? false,
          "delayed-departure-time": _ctx.delayedDepartureTime,
          "delayed-arrival-time": _ctx.delayedArrivalTime,
          "is-loading": _ctx.isLoading
        }, null, 8, ["departure-time", "arrival-time", "is-cancelled", "is-delayed", "delayed-departure-time", "delayed-arrival-time", "is-loading"])
      ])
    ]),
    (_ctx.stops && _ctx.stops.length > 2 && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.viewStopsText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(['accordionHeader', { expanded: expanded.value }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
                }, [
                  _createVNode(_unref(IconText), {
                    "icon-name": "mapPin",
                    text: _ctx.viewStopsText,
                    "icon-md": true
                  }, null, 8, ["text"]),
                  _createVNode(_unref(Icon), { "icon-name": "accordionArrow" })
                ], 2),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stops, (stop, index) => {
                    return (_openBlock(), _createElementBlock("ul", { key: index }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatInTimeZone)(stop.time, _unref(timezone), 'HH:mm')), 1),
                        _createTextVNode(" " + _toDisplayString(stop.port), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})